import provincesMapData from "../../data/map/ProvincesMapData";
import TerritoryMap, {
  webdipNameToTerritory,
  territoryToWebdipName,
  coastData,
} from "../../data/map/variants/classic/TerritoryMap";
import countryMap from "../../data/map/variants/classic/CountryMap";
import countryIDMap from "../../data/map/variants/classic/CountryIDMap";
import WDBoardMap from "../../components/map/components/WDBoardMap";
import CapturableLandTexture from "../../assets/textures/capturable-land.jpeg";
import WaterTexture from "../../assets/textures/sea-texture.png";
import { MapVariant } from "./types";

/*
经典七国地图。这是目前唯一的地图，也是 Classic / ClassicFvA / ClassicGvI
三个后端变体共用的几何（它们的 variantID 不同，但 mapID 指向同一张图）。
*/
const classicMapVariant: MapVariant = {
  key: "classic",
  name: "Classic",
  mapID: 1,
  variantIDs: [1, 15, 23],
  width: 6010,
  height: 3005,
  provincesMapData,
  territoryMap: TerritoryMap,
  webdipNameToTerritory,
  territoryToWebdipName,
  coastData: coastData as MapVariant["coastData"],
  countryMap,
  countryIDMap,
  textures: {
    capturableLand: {
      href: CapturableLandTexture,
      width: 1546,
      height: 1384,
      patternWidth: 1546,
      patternHeight: 1384,
    },
    sea: {
      href: WaterTexture,
      width: 1966,
      height: 1615,
      patternWidth: 1546,
      patternHeight: 1384,
    },
  },
  provincesToRenderLast: ["NAPLES", "ROME"],
  boardMap: WDBoardMap,
};

export default classicMapVariant;
